<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Optimized Velocity-Based Smooth Scroll Implementation with Smooth Acceleration and Deceleration
(() => {
    let velocity = 0; // Current scroll velocity
    const friction = 0.86; // Friction factor for deceleration (0 < friction < 1)
    const accelerationFactor = 0.16; // Acceleration multiplier based on wheel delta
    const maxVelocity = 80; // Maximum scroll velocity to prevent excessive speed
    let isAnimating = false; // Flag to check if the animation loop is running

    // Cache references to commonly accessed properties to reduce layout thrashing
    const documentElement = document.documentElement;
    const body = document.body;
    const scrollHeight = () => Math.max(
        body.scrollHeight,
        documentElement.scrollHeight,
        body.offsetHeight,
        documentElement.offsetHeight,
        body.clientHeight,
        documentElement.clientHeight
    );
    const windowHeight = () => window.innerHeight;

    /**
     * Smoothly updates the scroll position based on the current velocity.
     * Applies friction to gradually reduce velocity, simulating natural deceleration.
     */
    function animateScroll() {
        // Apply friction to velocity
        velocity *= friction;

        // Early exit if velocity is negligible
        if (Math.abs(velocity) < 0.1) {
            velocity = 0;
            isAnimating = false;
            return;
        }

        // Calculate the new scroll position
        let newScroll = (window.scrollY || window.pageYOffset || documentElement.scrollTop) + velocity;

        // Clamp the new scroll position within valid bounds
        newScroll = clamp(newScroll, 0, scrollHeight() - windowHeight());

        // Update the scroll position
        window.scrollTo(0, newScroll);

        // Continue the animation loop
        requestAnimationFrame(animateScroll);
    }

    /**
     * Handles the wheel event to adjust the scroll velocity.
     * @param {WheelEvent} event - The wheel event object.
     */
    function onWheel(event) {
        event.preventDefault(); // Prevent the default scrolling behavior

        // Normalize the wheel delta across different browsers/devices
        const deltaY = event.deltaY;

        // Update velocity based on wheel delta and acceleration factor
        velocity += deltaY * accelerationFactor;

        // Clamp velocity to the defined maximum limits
        velocity = clamp(velocity, -maxVelocity, maxVelocity);

        // Start the animation loop if not already running
        if (!isAnimating) {
            isAnimating = true;
            requestAnimationFrame(animateScroll);
        }
    }

    /**
     * Clamp function to restrict a value within a specified range.
     * @param {number} value - The value to clamp.
     * @param {number} min - The minimum allowable value.
     * @param {number} max - The maximum allowable value.
     * @returns {number} - The clamped value.
     */
    function clamp(value, min, max) {
        return Math.max(min, Math.min(value, max));
    }

    /**
     * Handle visibility change to pause animations when the tab is not active.
     * This prevents unnecessary animations and reduces CPU usage.
     */
    function onVisibilityChange() {
        if (document.hidden && isAnimating) {
            isAnimating = false;
            velocity = 0; // Optionally reset velocity
        }
    }

    // Attach the wheel event listener with passive: false to allow preventDefault
    window.addEventListener('wheel', onWheel, { passive: false });

    // Optional: Listen for visibility changes to optimize performance
    document.addEventListener('visibilitychange', onVisibilityChange);
})();

document.addEventListener("DOMContentLoaded", () => {
    // Array of classes to observe
    const animatedClasses = ['halo-row', 'img-box', 'policies-content', 'policies-icon', 'product-item', 'rte', 'shopify-section', 'slide-content', 'title'];
    const animatedClassSelector = animatedClasses.map(cls => `.${cls}`).join(', ');

    // Check for IntersectionObserver support
    if (!('IntersectionObserver' in window)) {
        // Fallback for older browsers
        document.querySelectorAll(animatedClassSelector).forEach(el => el.classList.add('gfx-in-view'));
        return;
    }

    // Observer options for stable behavior
    const observerOptions = {
        root: null, // Use the viewport as the root
        rootMargin: '0px', // No extra margins
        threshold: 0 // Trigger when 0% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add 'gfx-in-view' class and remove 'gfx-out-of-view'
                entry.target.classList.add('gfx-in-view');
                entry.target.classList.remove('gfx-out-of-view');
            } else {
                // Add 'gfx-out-of-view' class and remove 'gfx-in-view'
                entry.target.classList.add('gfx-out-of-view');
                entry.target.classList.remove('gfx-in-view');
            }
        });
    }, observerOptions);

    // Observe each element matching the animated classes
    document.querySelectorAll(animatedClassSelector).forEach((element) => observer.observe(element));
});

document.addEventListener("DOMContentLoaded", () => {
  // Select the element with the given class
  const badgeTextElement = document.querySelector(".jdgm-preview-badge .jdgm-prev-badge__text");

  // Ensure the element exists and contains text
  if (badgeTextElement && badgeTextElement.textContent.trim()) {
    try {
      // Extract the number from the element's text
      const textContent = badgeTextElement.textContent.trim();
      const numberMatch = textContent.match(/^(\d+)\b/); // Match number at the start of the string

      if (numberMatch) {
        const number = parseInt(numberMatch[1], 10); // Convert the matched string to a number

        // Check if the number is greater than 1
        if (number > 1 && !textContent.endsWith("s")) {
          // Append "s" to the text content if it doesn't already end with "s"
          badgeTextElement.textContent = `${textContent}s`;
        }
      }
    } catch (error) {
      console.error("An error occurred while processing the badge text:", error);
    }
  } else {
    console.warn("The element .jdgm-preview-badge .jdgm-prev-badge__text does not exist or is empty.");
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Select all <h1> elements with the "slide-heading" class
  const headings = document.querySelectorAll('h1.slide-heading');
  
  // Iterate over each heading and remove those that are empty (ignoring whitespace)
  headings.forEach(heading => {
    if (heading.textContent.trim() === '') {
      heading.remove();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // Cache the selection of all matching h2 elements within .slideshow-collection-feature
  const elements = document.querySelectorAll('.slideshow-collection-feature h2.slide-text');
  
  // Use a classic for-loop for optimal iteration performance
  for (let i = 0, len = elements.length; i < len; i++) {
    const oldElement = elements[i];
    const newElement = document.createElement('p');
    
    // Manually copy each attribute for optimal performance
    const attrs = oldElement.attributes;
    for (let j = 0, attrLen = attrs.length; j < attrLen; j++) {
      const attr = attrs[j];
      newElement.setAttribute(attr.name, attr.value);
    }
    
    // Copy inner HTML content
    newElement.innerHTML = oldElement.innerHTML;
    
    // Replace the old <h2> element with the new <p> element
    oldElement.replaceWith(newElement);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Cache all <h1> elements inside .slideshow-collection-feature
  const elements = document.querySelectorAll('.slideshow-collection-feature h1');
  
  // Use a classic for-loop for optimal performance
  for (let i = 0, len = elements.length; i < len; i++) {
    const oldElement = elements[i];
    const newElement = document.createElement('h2');
    
    // Copy each attribute from the old <h1> to the new <h2>
    const attrs = oldElement.attributes;
    for (let j = 0, attrLen = attrs.length; j < attrLen; j++) {
      const attr = attrs[j];
      newElement.setAttribute(attr.name, attr.value);
    }
    
    // Copy inner HTML content
    newElement.innerHTML = oldElement.innerHTML;
    
    // Replace the old <h1> element with the new <h2> element
    oldElement.replaceWith(newElement);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Cache all <h1> elements inside .slideshow-video-feature for optimal performance
  const elements = document.querySelectorAll('.slideshow-video-feature h1');
  
  // Iterate using a classic for-loop for best performance
  for (let i = 0, len = elements.length; i < len; i++) {
    const oldElement = elements[i];
    const newElement = document.createElement('h2');
    
    // Copy all attributes from the old <h1> to the new <h2>
    const attrs = oldElement.attributes;
    for (let j = 0, attrLen = attrs.length; j < attrLen; j++) {
      newElement.setAttribute(attrs[j].name, attrs[j].value);
    }
    
    // Copy the inner HTML content
    newElement.innerHTML = oldElement.innerHTML;
    
    // Replace the old <h1> with the new <h2> in the DOM
    oldElement.replaceWith(newElement);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Cache all <h2> elements with the "slide-text" class inside .slideshow-video-feature
  const elements = document.querySelectorAll('.slideshow-video-feature h2.slide-text');

  // Iterate using a classic for-loop for optimal performance
  for (let i = 0, len = elements.length; i < len; i++) {
    const oldElement = elements[i];
    const newElement = document.createElement('p');

    // Copy each attribute from the old element to the new one
    const attrs = oldElement.attributes;
    for (let j = 0, attrLen = attrs.length; j < attrLen; j++) {
      const attr = attrs[j];
      newElement.setAttribute(attr.name, attr.value);
    }

    // Copy the inner HTML content
    newElement.innerHTML = oldElement.innerHTML;

    // Replace the old <h2> element with the new <p> element in the DOM
    oldElement.replaceWith(newElement);
  }
});
